import { render, staticRenderFns } from "./vendorBusinessCatg.vue?vue&type=template&id=7caac0a2"
import script from "./vendorBusinessCatg.vue?vue&type=script&lang=js"
export * from "./vendorBusinessCatg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports